import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_USER, RETRIEVE_USER_LIST } from '../../data.const';
import {
  retrieveUserListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteUserEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_USER),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_USER}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ userLoader: true })),
        defer(() =>
          from(
            request({ path: `user`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_USER}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveUserListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_USER}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ userLoader: false }))
      );
    })
  );

export default deleteUserEpic;
